/** MONEYHUB_AUTH_CODE_FIELD is the name of the auth code parameter sent in the
 * hash fragment that's used to complete the connection to Moneyhub */
const MONEYHUB_AUTH_CODE_FIELD = 'code'
/** MONEYHUB_ERROR_FIELD is the name of the parameter sent in the hash fragment that
 * indicates when there was an error establishing a connection with the broker */
const MONEYHUB_ERROR_FIELD = 'error'

export { MONEYHUB_AUTH_CODE_FIELD, MONEYHUB_ERROR_FIELD }
